/* unplugin-vue-components disabled */import { render } from "./OpticalPathBoard.vue?vue&type=template&id=79f367df&scoped=true"
import script from "./OpticalPathBoard.vue?vue&type=script&lang=js"
export * from "./OpticalPathBoard.vue?vue&type=script&lang=js"

import "./OpticalPathBoard.vue?vue&type=style&index=0&id=79f367df&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/_vue-loader@17.4.2@vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-79f367df"]])

export default __exports__